import { App } from "antd";
import { useCallback, useState } from "react";
import { useAppDispatch } from "../../../../store";
import { useGetDeleteDialogProps } from "../../../../lib/hooks/getDeleteDialogProps";
import { deleteFeeType } from "../../../../acions/administration/fees";

export const useDeleteModal = (
  reloadData: () => void,
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const { modal } = App.useApp();

  const dispatch = useAppDispatch();

  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const [options] = useGetDeleteDialogProps(isDeleting);

  const openDeleteModal = useCallback(
    (req: any, title: string): void => {
      modal.confirm({
        ...options,
        title,
        content: (
          <div className="text-md mb-1">Are you sure you want to delete?</div>
        ),
        onOk: async () => {
          setIsDeleting(true);

          try {
            await Promise.resolve(dispatch(deleteFeeType(req)));
            setIsDeleting(false);
            reloadData();
            if (setIsOpen) {
              setIsOpen(false);
            }
          } catch {
            return setIsDeleting(false);
          }
        },
      });
    },
    [modal, options, dispatch, reloadData, setIsOpen]
  );

  return { openDeleteModal };
};
